import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation, ElementRef, ChangeDetectorRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { delay, filter, take, takeUntil } from 'rxjs/operators';

import { FuseConfigService } from '@fuse/services/config.service';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FusePerfectScrollbarDirective } from '@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';
import { HttpClient } from '@angular/common/http';
import { DATOS_API } from 'app/auth/auth.datos';
// INTERFACES DE ENVIO Y RESPUESTA AL BACKEND
import * as backInter from 'app/auth/auth-data.model';
import { lang_login} from 'app/idiomas/i18n/login/login.lang';
import { lang_editorEncuesta } from 'app/idiomas/i18n/editor-encuesta/editor-encuesta.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
////MOstrar Mensajes MOdal
import Swal from 'sweetalert2';
import {TranslateService} from '@ngx-translate/core';
import { MatSnackBar } from "@angular/material/snack-bar";
import { LyDialog } from '@alyle/ui/dialog';
import { ModalLogoComponent } from "./modal-logo/modal-logo.component";
///Formatos para Imagen
export const FORMATO_ADMITIDO = [
  'image/gif',
  'image/jpeg',
  'image/png'
];
import { ProgramacionService } from "app/main/wizard-cgo/services/programacion.service";
import *  as $ from 'jquery';
import { ToolbarService } from "app/layout/components/toolbar/toolbar.service";

@Component({
    selector     : 'navbar-vertical-style-1',
    templateUrl  : './style-1.component.html',
    styleUrls    : ['./style-1.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NavbarVerticalStyle1Component implements OnInit, OnDestroy
{
    // @ViewChild('fileInput', {read: undefined, static: true}) fileInput:ElementRef;

    fuseConfig: any;
    navigation: any;

    datosUsuario: any;

    // Private
    private _fusePerfectScrollbar: FusePerfectScrollbarDirective;
    private _unsubscribeAll: Subject<any>;

    //variables de autenticacion
    userIsAuthenticated = false;
    idUsuario: string;
    datosUsu: backInter.infoUsuario;
    datosEmp: backInter.infoEmpresa;

    rutaimagen = "assets/images/avatars/empIco.jpg";
    puedeCargarLogo = false;

    empresaPadre: string;
    titutloCGO:string;
    rutaLogo:string;
    instituto:any;
    usoLogo:any;
    urlImagenLog= DATOS_API.urlAssets;
    infoCargado=false;
    linkHomePage="";
    constructor(
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _fuseConfigService: FuseConfigService,
        private _fuseNavigationService: FuseNavigationService,
        private _fuseSidebarService: FuseSidebarService,
        private _router: Router,
        public authService: AuthService,
        private http:HttpClient,
        private translateSrv: TranslateService,
        private programacionService: ProgramacionService,
        private _snackBar: MatSnackBar,
        private _dialog: LyDialog,
        private _cd: ChangeDetectorRef,
        private tbs: ToolbarService
    )
    {

        lang_login.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
        });
        lang_editorEncuesta.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
        });

        // Set the private defaults
        this._unsubscribeAll = new Subject();
        if(localStorage.getItem('tipoIzzi')){
          // this.titutloCGO="ONE SURVEY";
          // this.rutaLogo="ONE_SURVEY.png";
          this.titutloCGO="CULTURAL GO®";
          this.rutaLogo="logo_GO.png";
        }
        else{
          this.titutloCGO="CULTURAL GO®";
          this.rutaLogo="logo_GO.png";
        }

        this.usoLogo=this.programacionService.ordenNavbar.subscribe( (resu) => {
          console.log("Entro");
          console.log("se envio orden desde programacion: ",resu);
          $("#inputImagen").click();
        });

        this.instituto=localStorage.getItem('instituto');
        // console.log(this.instituto);

        this.tbs.ordenNavbar.subscribe((datos:any) => {
          console.log("datosEnviadosDeToolbar:",datos);
          if(datos.status == true){
            this.rutaLogo = datos.jsons.generics.menuBrand.logo != "" ? datos.jsons.generics.menuBrand.logo : "assets/logo_GO.png";
            this.titutloCGO = datos.jsons.generics.menuBrand.name != "" ? datos.jsons.generics.menuBrand.name : "CULTURAL GO®";
          } else{
            this.rutaLogo = "assets/logo_GO.png";
            this.titutloCGO = "CULTURAL GO®";
          }
        });

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    // Directive
    @ViewChild(FusePerfectScrollbarDirective, {static: true})
    set directive(theDirective: FusePerfectScrollbarDirective)
    {
        if ( !theDirective )
        {
            return;
        }

        this._fusePerfectScrollbar = theDirective;

        // Update the scrollbar on collapsable item toggle
        this._fuseNavigationService.onItemCollapseToggled
            .pipe(
                delay(500),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => {
                this._fusePerfectScrollbar.update();
            });

        // Scroll to the active item position
        this._router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                take(1)
            )
            .subscribe(() => {
                    setTimeout(() => {
                        this._fusePerfectScrollbar.scrollToElement('navbar .nav-link.active', -120);
                    });
                }
            );
    }

    getDatosSide(){
      let esperaDatos = setInterval( () => {
				if(this.authService.getIsAuth())
				{
          if(this.authService.getInfoUsuario() != null){
            if(this.datosUsu == null){

              if(localStorage.getItem('empresaPadre')){
                // this.empresaPadre = localStorage.getItem('empresaPadre');
                this.getInfoEmpresa(localStorage.getItem('empresaPadre'));
                this.getImagenLogo(localStorage.getItem('empresaPadre'));
              }
              else this.empresaPadre = null;
              // console.log("entro al caso is auth");
              //BLOQUE INICIAL AUTENTICACION
              this.userIsAuthenticated = this.authService.getIsAuth();
              this.idUsuario = this.authService.getIdUsuario();
              this.datosUsu = this.authService.getInfoUsuario();
              this.infoCargado=true;
              console.log(this.authService.getInfoUsuario());
              switch (localStorage.getItem('instituto_id')) {
                case "1":
                  switch (this.datosUsu.level) {
                    case 1: case 4: case 19:
                    this.linkHomePage="/homepage";
                      break;
                    default:
                    this.linkHomePage="/home";
                      break;
                  }
                  break;
                default:
                this.linkHomePage="/home";
                  break;
              }

              if(this.datosUsu.level == 1 || this.datosUsu.level == 5 || this.datosUsu.level == 8 || this.datosUsu.level == 4 || this.datosUsu.level == 10 || this.datosUsu.level == 12 || this.datosUsu.level == 13  || this.datosUsu.level == 14 || this.datosUsu.level == 15 || this.datosUsu.level == 18 || this.datosUsu.level == 19){
                this.getInfoEmpresa();
                this.getImagenLogo();

                this.puedeCargarLogo = true;
                if(this.datosUsu.level == 4 || this.datosUsu.level == 12 || this.datosUsu.level == 14 || this.datosUsu.level == 15 || this.datosUsu.level == 18 || this.datosUsu.level == 19){  //resultados y actiongo
                  this.puedeCargarLogo = false;
                }
              }
              else{
                this.setInfoCards(this.datosUsu.level);
                this.puedeCargarLogo = false;
              }
    					clearInterval(esperaDatos);
            }
          }

				}
			}, 0);
    }

    getInfoEmpresa(empresaPadre?:string){
      let idEmpresa: string;
      if(empresaPadre){
        idEmpresa = empresaPadre;
      }
      else idEmpresa = this.datosUsu.empresaId;


      this.http.get(DATOS_API.url + DATOS_API.endpoints.empresas + idEmpresa)
      .subscribe((data:backInter.infoEmpresa) => {
          this.datosEmp = data;
          this.setInfoCards();
          // console.log(this.datosEmp);
        }, error  => {
          console.log("error");
        });
    }

    setInfoCards(origen?:number){
      // console.log("entro a cards");
      let nomImg: string;
      if(!origen)
      {
        if(this.datosEmp){
          if (!this.datosEmp.data.imagen) nomImg = 'empIco';
          else nomImg = this.datosEmp.data.imagen;
          this.datosUsuario = {
            'nombre': this.datosEmp.data.nombreEmpresa,
            'email': this.datosUsu.user,
            'avatar': nomImg
          };
        }
      }
      else{
        let nombre = "";
        let imgNom = "";
        let logoInstituto:string=localStorage.getItem('instituto_id');
        switch(origen){
          case 2:
           nombre = "Admin User";
           switch (logoInstituto) {
             case '14':
               imgNom = 'gcti';
               break;
             case '18':
             imgNom = 'amco';
               break;
             case '19':
             imgNom = 'innmotion';
               break;

             default:
               imgNom = 'GPTW';
               break;
           }

           break;
          case 3: case 4: nombre = "ITBM"; imgNom = nombre; break;
          case 7: nombre = "COVID Results"; imgNom = 'CGO'; break;
          case 11: nombre = "Izzi"; imgNom = 'Izzi';
          console.log("entro este visne");
           break;
        };
        this.datosUsuario = {
          'nombre': nombre,
          'email': this.datosUsu.user,
          'avatar': imgNom.toLowerCase()
        };
        // this.rutaimagen = "assets/images/avatars/"+nombre.toLowerCase()+".jpg";
        if (logoInstituto=='19') {
          this.rutaimagen = this.urlImagenLog+"platform/avatars/"+imgNom.toLowerCase()+".png";
        }else{
          this.rutaimagen = this.urlImagenLog+"platform/avatars/"+imgNom.toLowerCase()+".jpg";
        }
        console.log("rutaimagen NAV-BAR: ", this.rutaimagen);
      }

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
      this.getDatosSide();

      this.datosUsuario = {
        'nombre': '',
        'email': '',
        'avatar': 'empIco'
      };

        this._router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => {
                    if ( this._fuseSidebarService.getSidebar('navbar') )
                    {
                        this._fuseSidebarService.getSidebar('navbar').close();
                    }
                }
            );

        // Subscribe to the config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {
                this.fuseConfig = config;
            });

        // Get current navigation
        this._fuseNavigationService.onNavigationChanged
            .pipe(
                filter(value => value !== null),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => {
                this.navigation = this._fuseNavigationService.getCurrentNavigation();
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        this.usoLogo.unsubscribe();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar opened status
     */
    toggleSidebarOpened(): void
    {
        this._fuseSidebarService.getSidebar('navbar').toggleOpen();
    }

    /**
     * Toggle sidebar folded status
     */
    toggleSidebarFolded(): void
    {
        this._fuseSidebarService.getSidebar('navbar').toggleFold();
    }

    cargarImagenNueva(event: Event) {
      this._dialog.open<ModalLogoComponent, Event>(ModalLogoComponent, {
        data: event,
        disableClose: true
      }).afterClosed.subscribe((result?: any) => {
        let [resultado,objDrop] = result;
        if (resultado) {
          this._cd.markForCheck();
          console.log("resultado:",resultado);
          console.log("objDrop:",objDrop);

          fetch(resultado.dataURL)
            .then(res => res.blob()) // Gets the response and returns it as a blob
            .then(blob => {
              // Here's where you get access to the blob
              // And you can use it for whatever you want
              // Like calling ref().put(blob)

              // Here, I use it to make an image appear on the page
              // let objectURL = URL.createObjectURL(blob);
              // let myImage = new Image();
              // myImage.src = objectURL;
              // document.getElementById('myImg').appendChild(myImage)
              console.log("blob:",blob);
              // let nombreRandom = Math.floor(Math.random() * (999999 - 100000 + 1) ) + 100000;
              // let file = new File([blob], nombreRandom.toString(), {type: objDrop.type});
              let file = new File([blob], objDrop.name, {type: objDrop.type});
              console.log("file:",file);

              let fd = new FormData();
              fd.append('file', file, file.name);

              this.authService.saveLogo(fd).subscribe((data: backInter.logoEmpresa) => {

                if (data.message == "700") {
                  let url = DATOS_API.urlLogos.split(":");
                  this.rutaimagen = url[1] + "/surveyadministrator/backend/" + data.rutaArchivo;
                  this.mensajeSwal('LOGIN.FORM.CARGAOK', 1);
                  this.authService.puenteDatos("100");
                  this.programacionService.enviaProg("ya regrese prro");
                } else {
                  this.mensajeSwal('LOGIN.FORM.CARGANULL', 3);
                  // console.log(data);
                }
              });
              // this.guardaImagenCargada(file, idxPag, pagina, paso, elemento, idioma);

          });
        }
      });
    }

    cambiarImagen(evt: any) {
      const target: DataTransfer = < DataTransfer > (evt.target);
      if (target.files.length !== 1) throw new Error('Cannot use multiple files');
      // console.log(target.files[0].type);
      if (FORMATO_ADMITIDO.includes(target.files[0].type)) {

        const reader: FileReader = new FileReader();
        let archivo = evt.target.files[0];
        let fd = new FormData();
        fd.append('file', archivo, archivo.name);

        this.authService.saveLogo(fd).subscribe((data: backInter.logoEmpresa) => {

          if (data.message == "700") {
            let url = DATOS_API.url.split(":");
            this.rutaimagen = url[1] + "/surveyadministrator/backend/" + data.rutaArchivo;
            this.mensajeSwal('LOGIN.FORM.CARGAOK', 1);
            this.authService.puenteDatos("100");
            this.programacionService.enviaProg("ya regrese prro");
          } else {
            this.mensajeSwal('LOGIN.FORM.CARGANULL', 3);
            // console.log(data);
          }
        });
      } else {
          this.mensajeSwal('LOGIN.FORM.CARGAERROR', 2);
      }
    }

    getImagenLogo(empresaPadre?:string) {
      if(this.authService.getIsAuth())
      {
        this.authService.getLogo(empresaPadre).subscribe((data: backInter.getLogoEmpresa) => {
          // console.log(data);
          if (data.message == "702") {
            let url = DATOS_API.urlLogos.split(":");
            this.rutaimagen = url[1] + "/surveyadministrator/backend/" + data.rutaArchivo;
        // http://35.232.140.117/surveyadministrator/backend/

          } else if (data.message == "701") {
            this.rutaimagen = "assets/images/avatars/empIco.jpg";
            console.log(data);
          }
        });
      }
    }
    mensajeSwal(mensaje:string, tipoMsg:number){
      let texto = '';
      this.translateSrv.get(mensaje).subscribe((res: string) => { texto = res; });
      let tipo: any;
      switch(tipoMsg){
        case 1:
          tipo = 'success';
          this.Success_openSnackBar(texto,this.translateSrv.instant('ALERTS.OK') );
          //this.openSnackBar(succes,"OK");
        break;
        case 2:
          tipo = 'warning';
          this.Warning_openSnackBar(texto,this.translateSrv.instant('ALERTS.OK') );
        break;
        case 3:
          tipo = 'error';
          this.Error_openSnackBar(texto,this.translateSrv.instant('ALERTS.OK') );
        break;
      }


      /*Swal.fire({
        title: texto,
        type: tipo,
        confirmButtonColor: '#ff8f00'
      });*/
    }

    Success_openSnackBar(message: string, action: string) {
      this._snackBar.open(message, action, {
        duration: 2000,
        verticalPosition: 'bottom',
        panelClass: ['background-success']
      });
    }

    Error_openSnackBar(message: string, action: string) {
      this._snackBar.open(message, action, {
        duration: 2000,
        verticalPosition: 'bottom',
        panelClass: ['background-red']
      });
    }

    Warning_openSnackBar(message: string, action: string) {
      this._snackBar.open(message, action, {
        duration: 2000,
        verticalPosition: 'bottom',
        panelClass: ['background-warning']
      });
    }





}
